var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    open: _vm.isMenuOpen,
    'shadow-5': _vm.isMenuOpen || !_vm.fixedMenu,
    'menu-overlayed': !_vm.fixedMenu,
  },attrs:{"id":"menu-wrapper"}},[(_vm.isMenuOpen)?_c('div',{staticClass:"pos-fixed z-1 pos-all bg-default-5",class:{ 'hidden-md-up': _vm.fixedMenu },attrs:{"id":"menu-overlay"},on:{"click":function($event){_vm.isMenuOpen = false}}}):_vm._e(),_c('div',{staticClass:"pos-relative z-2",attrs:{"id":"menu-content"},on:{"mouseenter":_vm.onMouseEnterMenu,"mouseleave":_vm.onMouseLeaveMenu}},[_c('CrMenuList',{attrs:{"items":_vm.items,"opened-item":_vm.openedItem,"allow-expand":_vm.isMenuOpen},on:{"item-click":_vm.itemClicked}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }